import React from 'react';
import clsx from 'clsx';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';

const listUserGroup = (userGroup) => ({
  key: `user_dropdown_item_${userGroup.code}`,
  text: userGroup.name,
  value: userGroup.code,
});

const UsersGroupsDropdown = ({
  autoFocus,
  className,
  disabled,
  filter,
  groups,
  onChange,
  onFilterChange,
  readStatus,
  text,
  user,
}) => {
  const intl = useIntl();
  return (
    <Dropdown
      autoFocus={autoFocus}
      className={clsx('aridhia-users-dropdown mt-0', className)}
      disabled={disabled}
      fluid
      loading={readStatus === states.PENDING}
      multiple
      noResultsMessage={intl.formatMessage({ id: 'find.groups.none' })}
      onChange={(e, { value }) => { onChange(value); }}
      onSearchChange={
        (e, { searchQuery }) => { onFilterChange(searchQuery, user); }
      }
      options={groups.map((group) => listUserGroup(group))}
      placeholder={intl.formatMessage({ id: 'find.groups.placeholder' })}
      search={(options) => options}
      searchQuery={filter}
      selection
      value={text}
    />
  );
};

export default UsersGroupsDropdown;
